import type { LocalePack } from './types.js';

/** Korean (한국어) */
export const ko: LocalePack = {
  headerTitle: '사진 편집기',
  headerSubtitle: '이미지를 손쉽게 편집하세요',
  applyButton: '적용',
  cancelButton: '닫기',
  undo: '실행 취소',
  redo: '다시 실행',
  fullscreen: '전체 화면',
  fit: '맞춤',
  zoomTooltip: '확대/축소 · +/− · 0 맞춤 · 1 100%',

  emptyStateTitle: '이미지를 놓거나 클릭하여 업로드하세요',
  emptyStateSubtitle: '지원 형식: PNG, JPEG, HEIC',

  calloutLabelText: '레이블',

  tool: {
    select: '선택',
    crop: '자르기',
    draw: '그리기',
    eraser: '지우개',
    text: '텍스트',
    shapes: '도형',
    callout: '설명선',
    filters: '필터',
    adjust: '조정',
    move: '이동',
    pen: '펜',
    zoom: '확대/축소',
    zoomIn: '확대',
    zoomOut: '축소',
    rotateLeft: '왼쪽으로 회전',
    rotateRight: '오른쪽으로 회전',
    flipH: '가로 뒤집기',
    flipV: '세로 뒤집기',
    reset: '초기화',
  },

  shape: {
    circle: '원',
    ellipse: '타원',
    square: '정사각형',
    rectangle: '사각형',
    arrow: '화살표',
    polyline: '선 경로',
  },

  filter: {
    none: '원본',
    grayscale: '흑백',
    sepia: '세피아',
    vintage: '빈티지',
    cool: '차가운',
    warm: '따뜻한',
    invert: '반전',
  },

  props: {
    title: {
      draw: '그리기',
      eraser: '지우개',
      text: '텍스트',
      crop: '자르기',
      shapes: '도형',
      callout: '설명선',
      filters: '필터',
      adjust: '조정',
      move: '이동',
    },
    aspectRatio: '가로세로 비율',
    applyCrop: '자르기 적용',
    cancel: '취소',
    shape: '도형',
    preset: '프리셋',
    resetEffects: '효과 초기화',
    resetAdjustments: '조정 초기화',
    deleteSelected: '선택 항목 삭제',
    colors: '색상',
    recent: '최근',
    customColor: '사용자 지정 색상',
    brushSize: '브러시 크기',
    strokeWidth: '선 굵기',
    opacity: '불투명도',
    eraserSize: '지우개 크기',
    fontSize: '글꼴 크기',
    brightness: '밝기',
    contrast: '대비',
    saturation: '채도',
    blur: '흐림',
    quickActions: '빠른 작업',
    hintMove:
      '드래그하여 이동 · 핀치 또는 스크롤로 확대/축소 · 도구를 선택하여 편집을 시작하세요.',
    hintEraser: '주석 위를 탭하거나 드래그하여 제거하세요.',
  },
};
